import { Component, type ErrorInfo, type ReactNode } from "react";

import { Alert, Button, Typography } from "antd";

const { Paragraph, Text } = Typography;

/**
 * Impide que un fallo en un componente borre la pantalla entera.
 *
 * Sin esto, aceptar una sugerencia que dejaba un campo con la forma equivocada
 * tumbaba React y la persona se quedaba mirando un rectangulo blanco, sin su
 * hoja de vida y sin saber que habia pasado. Un editor puede tener errores;
 * lo que no puede es hacer desaparecer el trabajo de alguien sin decir nada.
 *
 * Sus cambios siguen en el servidor: el autoguardado ya los subio.
 */
export class Salvavidas extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Queda en la consola para poder diagnosticarlo con el usuario delante.
    console.error("[editor] fallo no controlado", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{ maxWidth: 620, margin: "0 auto", padding: "64px 24px" }}>
        <Alert
          type="error"
          showIcon
          message="Algo se rompió en el editor"
          description={
            <>
              <Paragraph style={{ marginBottom: 8 }}>
                Tus cambios están guardados en el servidor; no has perdido nada.
                Recarga la página para seguir.
              </Paragraph>
              <Paragraph type="secondary" style={{ marginBottom: 12, fontSize: 12.5 }}>
                <Text code>{this.state.error.message}</Text>
              </Paragraph>
              <Button type="primary" onClick={() => window.location.reload()}>
                Recargar
              </Button>
            </>
          }
        />
      </div>
    );
  }
}
